import { useContext } from 'react';
import { TextField } from '@mui/material';
import { format } from 'date-fns';
import type { useForm } from 'react-hook-form';
import GoalInput from '@/components/GroupProject/GoalInput';
import { Textarea } from '@trinity/chat-components/components/presentation/index.js';
import * as Tab from '@/components/presentation/Workspace.Tab.Pane';
import * as consts from '@/consts/max-character-counts';
import { ProjectTypeMap } from '@/enums';
import { cx } from '@trinity/chat-components';
import { ProjectDetailsContext } from '../Project.Main/Context';
import type { ProjectDetailsFormValue } from './interfaces';
import styles from './style/Project.Details.module.css';

export const ProjectDetailsEditForm = ({ form }: { form: ReturnType<typeof useForm<ProjectDetailsFormValue>> }) => {
  const ctx = useContext(ProjectDetailsContext);

  // TODO: Enable when accounts are supported
  // const query = useQuery({
  //   queryKey: [`get:groups/search`],
  //   queryFn: api.groups.fetchAccounts,
  // });

  // const accounts = useMemo(() => {
  //   const items = query.data?.data.items ?? [];
  //   return {
  //     autofill: items.map(x => ({
  //       code: x.attributes?.code,
  //       id: x.id,
  //       name: x.name,
  //     })),
  //     options: items,
  //   };
  // }, [query.data]);

  return (
    <Tab.Pane.Grid gridTemplateColumns='repeat(2, 0.5fr)'>
      <Tab.Items.Container>
        <Tab.Item.Container>
          <Tab.Item.TextLabel>Respondent Title</Tab.Item.TextLabel>
          <Tab.Item.Value>
            <TextField
              fullWidth
              type="text"
              onChange={e => form.setValue('name', e.target.value)}
              value={form.watch('name')}
              variant="standard" />
          </Tab.Item.Value>
        </Tab.Item.Container>
        <Tab.Item.Container>
          <Tab.Item.TextLabel>Client Title</Tab.Item.TextLabel>
          <Tab.Item.Value>
            <TextField
              fullWidth
              type="text"
              onChange={e => form.setValue('clientName', e.target.value)}
              value={form.watch('clientName')}
              variant="standard" />
          </Tab.Item.Value>
        </Tab.Item.Container>
        {/* <Tab.Item.Container>
          <Tab.Item.TextLabel>Client Account</Tab.Item.TextLabel>
          <Tab.Item.Value>
            <SelectSearch
              clearable
              onChange={x => form.setValue('accountId', x?.id)}
              options={accounts.options}
              placeholder="Client Account"
              value={form.watch('accountId') ? Number(form.watch('accountId')) : undefined} />
          </Tab.Item.Value>
        </Tab.Item.Container> */}

        <Tab.Item.Container>
          <Tab.Item.TextLabel>Description</Tab.Item.TextLabel>
          <Tab.Item.Value>
            <Textarea
              maxLength={consts.PROJECT_DESCRIPTION}
              onChange={e => form.setValue('description', e.target.value)}
              value={form.watch('description')}
              style={{ minHeight: 90 }} />
          </Tab.Item.Value>
        </Tab.Item.Container>

        <Tab.Item.Container>
          <Tab.Item.TextLabel>Goal</Tab.Item.TextLabel>
          <Tab.Item.Value>
            <GoalInput
              onChange={value => form.setValue('goal', Number(value))}
              type={ctx.query.data.project.projectTypeId}
              value={form.watch('goal')} />
          </Tab.Item.Value>
        </Tab.Item.Container>
      </Tab.Items.Container>

      <Tab.Items.Container>
        <Tab.Item.Container>
          <Tab.Item.TextLabel>Methodology</Tab.Item.TextLabel>
          <Tab.Item.Value>
            {ProjectTypeMap.getName(ctx.query.data.project.projectTypeId)}
          </Tab.Item.Value>
        </Tab.Item.Container>
        <Tab.Item.Container>
          <Tab.Item.TextLabel>Start Date</Tab.Item.TextLabel>
          <Tab.Item.Value>
            {ctx.query.data.project.startDate && <div>{format(new Date(ctx.query.data.project.startDate), 'MM/dd/yy')}</div>}
            {!ctx.query.data.project.startDate && <div className={cx(styles.field, styles.na)}>N/A</div>}
          </Tab.Item.Value>
        </Tab.Item.Container>
        <Tab.Item.Container>
          <Tab.Item.TextLabel>Target Complete Date</Tab.Item.TextLabel>
          <Tab.Item.Value>
            {ctx.query.data.project.targetCompleteDate && <div className={styles.field}>{format(new Date(ctx.query.data.project.targetCompleteDate), 'MM/dd/yy')}</div>}
            {!ctx.query.data.project.targetCompleteDate && <div className={cx(styles.field, styles.na)}>N/A</div>}
          </Tab.Item.Value>
        </Tab.Item.Container>
        {/* <$TargetCompany>
                  <Tab.Item.Container>
                    <TargetCompany editable={canEdit} item={project} />
                  </Tab.Item.Container>
                </$TargetCompany> */}

      </Tab.Items.Container>
    </Tab.Pane.Grid>
  );
};